module.exports = __webpack_public_path__ + "static/bzyxyfsyy-7c4dae8b6b310000e77996b2b4757e9c.jpg";